import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {COURSE, COURSE_API_URL, GET_ALL_COURSE_API_URL} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  CourseErrors       : {},
  permission: permission?.course ?? [],
  CourseShowMessage  : null,
  CourseResult       : [],
  CourseButtonSpinner : false,
  CourseTableLoading : true,
  CourseAddDrawer    : false,
  CourseEditData     : [],
  CourseButtonAndModelLabel  : setLocale('course.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewCourseData: [],
    ViewCourseLoader: true,
    DrawerStatus: 0,
};

export const createCourse = createAsyncThunk(
    "createCourse",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, COURSE_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getCourse = createAsyncThunk(
    "getCourse",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_COURSE_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const viewCourse = createAsyncThunk(
  "viewCourse",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, COURSE_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const deleteCourse = createAsyncThunk(
  "deleteCourse",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, COURSE_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const manageCourseSlice = createSlice({
  name: COURSE,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.CourseErrors = {};
    },
    CourseAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.CourseButtonSpinner = false;
      }
      state.CourseAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.CourseEditData    = [];
      state.CourseButtonAndModelLabel = setLocale('course.add');
    },
    CourseEditWithDrawerStatus: (state, action) => {
      state.CourseAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.CourseEditData = action.payload.data;
      state.CourseButtonAndModelLabel = setLocale('course.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCourse.pending, (state, action) => {
        state.DrawerStatus = 0
        state.CourseButtonSpinner = true;
      }).addCase(createCourse.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.CourseButtonSpinner = false;
        state.CourseErrors = {}
      }).addCase(createCourse.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.CourseShowMessage = true;
        state.CourseButtonSpinner = false;
        state.CourseErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      }).addCase(getCourse.pending, (state, action) => {
        state.CourseButtonSpinner = true;
        state.CourseTableLoading = true;
      }).addCase(getCourse.fulfilled, (state, action) => {
        state.CourseButtonSpinner = false;
        state.CourseTableLoading = false;
        state.CourseResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getCourse.rejected, (state, action) => {
        state.CourseShowMessage = true; // Set the showMessage flag to display the errors
        state.CourseButtonSpinner = false;
        state.CourseTableLoading = false;
        state.CourseErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      })
      .addCase(viewCourse.pending, (state, action) => {
        state.ViewCourseLoader = true;
        state.ViewCourseData = [];
      }).addCase(viewCourse.fulfilled, (state, action) => {
        state.ViewCourseLoader = false;
        state.ViewCourseData = action.payload;
      }).addCase(viewCourse.rejected, (state, action) => {
        state.ViewCourseLoader = false;
        state.ViewCourseData = [];
      })
      .addCase(deleteCourse.pending, (state, action) => {
        state.CourseTableLoading = true;
      }).addCase(deleteCourse.fulfilled, (state, action) => {
        state.CourseTableLoading = false;
      }).addCase(deleteCourse.rejected, (state, action) => {
        state.CourseTableLoading = false;
      });
  },
});

export const { onCloseError, setColumnSearch, CourseAddDrawerStatus, CourseEditWithDrawerStatus, updateSortFilters } = manageCourseSlice.actions;

export default manageCourseSlice.reducer;